import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
    Button,
    Collapse,
    IconButton,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import Backend from "../Backend";
import getShopUrl from "../getShopUrl";
import useAuthentication from "./state/useAuthentication";

export default function VirtuDesktopPromotionBanner() {
    const { authenticationState } = useAuthentication();
    const isAuthenticated =
        authenticationState.type === "REGISTERED_USER_AUTHENTICATED";

    const [isEligibleForTrial, setIsEligibleForTrial] = useState<boolean>();

    useEffect(() => {
        async function run() {
            if (!isAuthenticated) {
                return;
            }
            const isEligible = await Backend.isEligibleForDesktopTrial();
            setIsEligibleForTrial(isEligible);
        }

        run();
    }, [isAuthenticated]);

    const shouldDisplayTrialBanner =
        !isAuthenticated || isEligibleForTrial === true;

    const [visible, setVisible] = useState(true);

    const theme = useTheme();
    const horizontalLayout = useMediaQuery(theme.breakpoints.up("md"));

    if (isAuthenticated && isEligibleForTrial === undefined) {
        return null;
    }

    const bannerInfo = shouldDisplayTrialBanner
        ? {
              url: `${getShopUrl()}/checkout/review-and-submit?catalogItemReferenceIds=slate-digital-meta-bundle-free-trial`,
              headingText:
                  "Try the VIRTU Desktop App — get unlimited mastering, real-time preview, and faster processing",
              buttonText: "Try Desktop App for free",
          }
        : {
              url: `${getShopUrl()}/installers#production-tools`,
              headingText:
                  "Unlock unlimited mastering, real-time preview, and faster processing with the new VIRTU Desktop App",
              buttonText: "Download VIRTU Desktop App",
          };

    return (
        <Collapse in={visible}>
            <Stack
                aria-label="Get Virtu Desktop App"
                direction={horizontalLayout ? "row" : "column"}
                spacing={2}
                sx={{
                    padding: "12px 50px",
                    background: "#2E7BA1",
                    position: "relative",
                    minHeight: "56px",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Typography fontWeight="700" fontSize="16px">
                    {bannerInfo.headingText}
                </Typography>
                <Button
                    component="a"
                    href={bannerInfo.url}
                    variant="soft"
                    color="secondary"
                    style={{ flexShrink: 0 }}
                >
                    <Typography
                        fontWeight="600"
                        fontSize="14px"
                        lineHeight="28px"
                    >
                        {bannerInfo.buttonText}
                    </Typography>
                </Button>
                <IconButton
                    aria-label="close"
                    onClick={() => setVisible(false)}
                    style={{ position: "absolute", top: 8, right: 16 }}
                >
                    <CloseRoundedIcon />
                </IconButton>
            </Stack>
        </Collapse>
    );
}
